import { applyToRecommendedJob, loadRecommendedJobs, loadFastrackFlows, loadJobsApplied, loadJobsV2 } from "../../services/commonAPI";

const JobsActions = {
  SET_JOBS: 'SET_JOBS',
  SET_RECOMMENDED_JOBS: 'SET_RECOMMENDED_JOBS',
  START_FETCHING_RECOMMENDED_JOBS: 'START_FETCHING_RECOMMENDED_JOBS',
  END_FETCHING_RECOMMENDED_JOBS: 'END_FETCHING_RECOMMENDED_JOBS',
  START_APPLYING_RECOMMENDED_JOBS: 'START_APPLYING_RECOMMENDED_JOBS',
  FINISH_APPLYING_RECOMMENDED_JOBS: 'FINISH_APPLYING_RECOMMENDED_JOBS',
  ERROR_APPLYING_RECOMMENDED_JOBS: 'ERROR_APPLYING_RECOMMENDED_JOBS',
  SET_FASTRACK_FLOWS: 'SET_FASTRACK_FLOWS',
  START_FETCHING_FASTRACK_FLOWS: 'START_FETCHING_FASTRACK_FLOWS',
  END_FETCHING_FASTRACK_FLOWS: 'END_FETCHING_FASTRACK_FLOWS',
  FETCH_JOBS_APPLIED:'FETCH_JOBS_APPLIED',
  START_FETCHING_JOBS_APPLIED:'START_FETCHING_JOBS_APPLIED',
  END_FETCHING_JOBS_APPLIED:'END_FETCHING_JOBS_APPLIED',
  SET_JOBS_APPLIED:'SET_JOBS_APPLIED',
  START_FETCHING_V2_JOBS: 'START_FETCHING_V2_JOBS',
  SET_V2_JOBS: 'SET_V2_JOBS',
  END_FETCHING_V2_JOBS: 'END_FETCHING_V2_JOBS',
  SET_PENDING_JRF: 'SET_PENDING_JRF',
};

const FETCH_RECOMMENDED_JOBS = (dispatch) => {
  dispatch({ type: JobsActions.START_FETCHING_RECOMMENDED_JOBS });
  loadRecommendedJobs().then((jobs) => {
    dispatch({ type: JobsActions.SET_RECOMMENDED_JOBS, payload: jobs });
  })
    .finally(() => dispatch({ type: JobsActions.END_FETCHING_RECOMMENDED_JOBS }));
};

const APPLY_TO_RECOMMENDED_JOBS = jobId => (dispatch) => {
  dispatch({ type: JobsActions.START_APPLYING_RECOMMENDED_JOBS });

  applyToRecommendedJob(jobId).then((response) => {
    dispatch({ type: JobsActions.FINISH_APPLYING_RECOMMENDED_JOBS, payload: response.data.url });
  })
    .catch(() => dispatch({ type: JobsActions.ERROR_APPLYING_RECOMMENDED_JOBS }));
}

const FETCH_FASTRACK_FLOWS = (dispatch) => {
  dispatch({ type: JobsActions.START_FETCHING_FASTRACK_FLOWS });

  loadFastrackFlows().then((flows) => {
    dispatch({ type: JobsActions.SET_FASTRACK_FLOWS, payload: flows });
  })
    .finally(() => dispatch({ type: JobsActions.END_FETCHING_FASTRACK_FLOWS }));
};

const FETCH_JOBS_APPLIED = (dispatch) => {
  dispatch({ type: JobsActions.START_FETCHING_JOBS_APPLIED });

  loadJobsApplied().then((jobs) => {
    dispatch({ type: JobsActions.SET_JOBS_APPLIED, payload: jobs });
  })
    .finally(() => dispatch({ type: JobsActions.END_FETCHING_JOBS_APPLIED }));
};

const FETCH_JOBS_V2 = (dispatch) => {
  dispatch({ type: JobsActions.START_FETCHING_V2_JOBS });

  loadJobsV2().then(({ jobs }) => {
    dispatch({ type: JobsActions.SET_V2_JOBS, payload: jobs})
  })
    .finally(() => dispatch({ type: JobsActions.END_FETCHING_V2_JOBS }))
}

const UPDATE_JOBS_V2 = (jobs) => dispatch => {
    dispatch({ type: JobsActions.SET_V2_JOBS, payload: jobs})
}

export default {
  ...JobsActions,
  FETCH_RECOMMENDED_JOBS,
  APPLY_TO_RECOMMENDED_JOBS,
  FETCH_FASTRACK_FLOWS,
  FETCH_JOBS_APPLIED,
  FETCH_JOBS_V2,
  UPDATE_JOBS_V2,
};
